import { render, staticRenderFns } from "./dbSchema.vue?vue&type=template&id=f25ca50c&"
import script from "./dbSchema.vue?vue&type=script&lang=js&"
export * from "./dbSchema.vue?vue&type=script&lang=js&"
import style0 from "./dbSchema.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports